
<v-card flat outlined @click = "onSelected" :ripple = false :class="background" :key = "refresh" class="v-flex">
    <div
        class="order-color"
        :style="'background-color:' + order.color"
    >
    </div>
    <div class="w-100">
        <div class="v-flex primary--text pa-2 pt-2 pb-0 pl-3" style="font-weight: 500;">
            <div v-if="prioritize" style="margin-top: -1px">
                <v-icon size="22">mdi-drag</v-icon>
            </div>
            <div class="order-title">
                {{ order.customer.name }}
            </div>
            <v-spacer />
            <div class="order-title">

            </div>

            <div class="ml-2 icon-gap">
                <c-toolbar-button
                    v-if     = "isDisponent"
                    size     = "18"
                    color    = "primary"
                    icon     = "mdi-pencil"
                    :tooltip = "$t('disposition.order.edit')"
                    @click   = "onEdit"
                />
            </div>

            <!-- remove order, only possible without any assigned inspection -->
            <div class="ml-0 icon-gap" v-if="assigned === 0">
                <c-toolbar-button
                    v-if     = "isDisponent"
                    size     = "18"
                    color    = "red"
                    icon     = "mdi-minus-box"
                    :tooltip = "$t('disposition.order.remove.tooltip')"
                    @click   = "onRemove"
                />
            </div>
        </div>

        <!--
        <v-divider style="margin-top: 0; margin-bottom: 2px;" />
-->
        <div
            class="ml-3 mr-3 v-flex secondary--text"
            :class="compact ? 'pb-2' : 'pb-0'"
            style="font-size: 13px; padding-top: 0px;"
        >
            <div>
                {{ order.no }} / {{ order.status.name }}
            </div>
            <v-spacer />
            <div>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                        <div v-on   = "{ ...tooltip }" >
                            {{ done }} / {{ dispatched}} / {{ assigned }} <span class="new-tag" v-if="isNew > 0">Neu</span>
                        </div>
                    </template>

                    <div style="width: 210px">
                        <v-row class="no-gutters">
                            <v-col class="col-9 pl-2">
                                davon erledigt
                            </v-col>
                            <v-col class="col-3 text-right">
                                {{ done }}
                            </v-col>
                        </v-row>
                        <v-row class="no-gutters">
                            <v-col class="col-9 pl-2">
                                davon zugeordnet
                            </v-col>
                            <v-col class="col-3 text-right">
                                {{ dispatched }}
                            </v-col>
                        </v-row>
                        <v-row class="no-gutters">
                            <v-col class="col-9 pl-2">
                                Begehungen insgesamt
                            </v-col>
                            <v-col class="col-3 text-right">
                                {{ assigned }}
                            </v-col>
                        </v-row>
                    </div>
                </v-tooltip>
            </div>
        </div>

        <div v-if="!compact" class="v-flex ml-2 pb-2 " style="padding-top: 2px; padding-bottom: 6px;">
            <p-disposition-status
                :value = "order.scope.elevator"
                icon   = "mdi-elevator"
                class  = "mr-3"
            />

            <p-disposition-status
                :value = "order.scope.sticker"
                icon   = "mdi-qrcode"
                class  = "mr-3"
            />

            <p-disposition-status
                :value = "order.scope.lgs"
                icon   = "mdi-router-wireless"
                class  = "mr-3"
            />

            <p-disposition-status
                :value = "order.scope.condition"
                icon   = "mdi-elevator"
                class  = "mr-3"
            />

            <p-disposition-status
                :value = "order.scope.audit"
                icon   = "mdi-clipboard-check-outline"
                class  = "mr-3"
            />

            <p-disposition-status
                :value = "order.scope.esg"
                icon   = "mdi-heart"
                class  = "mr-3"
            />
        </div>
    </div>
</v-card>
